var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Information Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99935 6.4165V9.9165M12.8327 6.99984C12.8327 10.2215 10.221 12.8332 6.99935 12.8332C3.77769 12.8332 1.16602 10.2215 1.16602 6.99984C1.16602 3.77818 3.77769 1.1665 6.99935 1.1665C10.221 1.1665 12.8327 3.77818 12.8327 6.99984Z",
    stroke: "#0E0F19",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.58268 4.66634C7.58268 4.98851 7.32151 5.24967 6.99935 5.24967C6.67718 5.24967 6.41602 4.98851 6.41602 4.66634C6.41602 4.34418 6.67718 4.08301 6.99935 4.08301C7.32151 4.08301 7.58268 4.34418 7.58268 4.66634Z",
    fill: "#0E0F19"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/Information Circle.e578e62986c066591313618951442d65.svg";
export { ForwardRef as ReactComponent };